var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector, Store } from '@ngxs/store';
import { PublishStateModel } from './publish.state.model';
import { SetPublishDimensions, GetPublishURL, GetPublishIFrame, GetPublishURLSuccess, GetPublishIFrameSuccess, GetPublishURLFail, GetPublishIFrameFail, SetPublishWidgetURL, SetPublishing, ResetPublish, GetPublishImageCode, GetPublishImageCodeSuccess, GetPublishImageCodeFail, SavePublishImage, SavePublishImageFail, SavePublishImageSuccess } from './publish.actions';
import { PublishService, PublishLinkType } from '../publish.service';
import { defaultScreen } from '../data/screens';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { forkJoin } from 'rxjs';
const defaultWidgetURL = '/viewer';
const initialState = {
    publishing: false,
    widgetURL: defaultWidgetURL,
    dimensions: defaultScreen.dimensions,
    minDimensions: {
        width: 300,
        height: 400
    }
};
let PublishState = class PublishState {
    constructor(publishService, store) {
        this.publishService = publishService;
        this.store = store;
    }
    static getDimensions(state) {
        return state.dimensions;
    }
    static getMinDimensions(state) {
        return state.minDimensions;
    }
    static getWidgetURL(state) {
        return state.widgetURL;
    }
    static getPublishing(state) {
        return state.publishing;
    }
    setPublishWidgetURL(context, action) {
        context.patchState({
            widgetURL: action.widgetURL || defaultWidgetURL
        });
    }
    setPublishDimensions(context, action) {
        context.patchState({
            dimensions: action.dimensions
        });
    }
    getPublishURL(context, action) {
        const { model, camera, widgetOptions } = action;
        const { widgetURL } = context.getState();
        const lang = this.store.selectSnapshot(AuthState.getUserLanguage);
        const app = this.store.selectSnapshot(AuthState.getSelectedUserApp);
        // get url
        this.publishService.generateWidgetURL(model, widgetURL, widgetOptions, camera, PublishLinkType.Single, lang, app)
            .subscribe((url) => {
            context.dispatch(new GetPublishURLSuccess(model, url));
        }, () => {
            context.dispatch(new GetPublishURLFail(model));
        });
    }
    getPublishIFrame(context, action) {
        const { model, camera, widgetOptions } = action;
        const { widgetURL, dimensions } = context.getState();
        const lang = this.store.selectSnapshot(AuthState.getUserLanguage);
        const app = this.store.selectSnapshot(AuthState.getSelectedUserApp);
        // get embed code
        this.publishService.generateWidgetEmbed(model, widgetURL, widgetOptions, dimensions, camera, PublishLinkType.Single, lang, app)
            .subscribe((embedCode) => {
            context.dispatch(new GetPublishIFrameSuccess(embedCode));
        }, () => {
            context.dispatch(new GetPublishIFrameFail());
        });
    }
    savePublishImage(context, { imageData }) {
        this.publishService.saveUserImage(imageData)
            .subscribe((imageURL) => {
            context.dispatch(new SavePublishImageSuccess(imageURL));
        }, () => {
            context.dispatch(new SavePublishImageFail());
        });
    }
    getPublishImage(context, action) {
        const { model, camera, widgetOptions, imageData } = action;
        const { widgetURL } = context.getState();
        const lang = this.store.selectSnapshot(AuthState.getUserLanguage);
        const app = this.store.selectSnapshot(AuthState.getSelectedUserApp);
        forkJoin(this.publishService.generateWidgetURL(model, widgetURL, widgetOptions, camera, PublishLinkType.Single, lang, app), // generate widget url
        this.publishService.saveUserImage(imageData) // generate image url      
        )
            .subscribe(([generatedWidgeURL, generatedImageURL]) => {
            const embed = this.publishService.getImageEmbed(model.title, generatedWidgeURL, generatedImageURL);
            context.dispatch(new GetPublishImageCodeSuccess(embed));
        }, () => {
            context.dispatch(new GetPublishImageCodeFail());
        });
    }
    setPublishing(context, { publishing }) {
        context.patchState({
            publishing: publishing
        });
    }
    resetPublish(context, action) {
        context.setState(initialState);
    }
};
__decorate([
    Action(SetPublishWidgetURL),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetPublishWidgetURL]),
    __metadata("design:returntype", void 0)
], PublishState.prototype, "setPublishWidgetURL", null);
__decorate([
    Action(SetPublishDimensions),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetPublishDimensions]),
    __metadata("design:returntype", void 0)
], PublishState.prototype, "setPublishDimensions", null);
__decorate([
    Action(GetPublishURL),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetPublishURL]),
    __metadata("design:returntype", void 0)
], PublishState.prototype, "getPublishURL", null);
__decorate([
    Action(GetPublishIFrame),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetPublishIFrame]),
    __metadata("design:returntype", void 0)
], PublishState.prototype, "getPublishIFrame", null);
__decorate([
    Action(SavePublishImage),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SavePublishImage]),
    __metadata("design:returntype", void 0)
], PublishState.prototype, "savePublishImage", null);
__decorate([
    Action(GetPublishImageCode),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetPublishImageCode]),
    __metadata("design:returntype", void 0)
], PublishState.prototype, "getPublishImage", null);
__decorate([
    Action(SetPublishing),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetPublishing]),
    __metadata("design:returntype", void 0)
], PublishState.prototype, "setPublishing", null);
__decorate([
    Action(ResetPublish),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ResetPublish]),
    __metadata("design:returntype", void 0)
], PublishState.prototype, "resetPublish", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [PublishStateModel]),
    __metadata("design:returntype", void 0)
], PublishState, "getDimensions", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [PublishStateModel]),
    __metadata("design:returntype", void 0)
], PublishState, "getMinDimensions", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [PublishStateModel]),
    __metadata("design:returntype", void 0)
], PublishState, "getWidgetURL", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [PublishStateModel]),
    __metadata("design:returntype", void 0)
], PublishState, "getPublishing", null);
PublishState = __decorate([
    State({
        name: 'publish',
        defaults: initialState
    }),
    __metadata("design:paramtypes", [PublishService,
        Store])
], PublishState);
export { PublishState };
